import React from 'react';
import { Section } from './ui/Section';
import { Quote, Star } from 'lucide-react';
interface Testimonial {
  initials: string;
  name: string;
  role: string;
  quote: string;
  color: string;
}
const initialTestimonials: Testimonial[] = [{
  initials: 'MP',
  name: 'Mariana P. — Buenos Aires',
  role: 'PROFESORA DE GIMNASIA ARTÍSTICA EN CLUB DEPORTIVO',
  quote: 'Organicé todo mi año de artística en una tarde. Tengo cada clase pensada y secuenciada para todos mis grupos. Nunca más el domingo de pánico.',
  color: 'bg-blue-500'
}, {
  initials: 'LR',
  name: 'Laura R. — Rosario',
  role: 'PROFE DE ARTÍSTICA EN ACADEMIA PARTICULAR',
  quote: 'Las progresiones por aparato cambiaron todo. Mis alumnas avanzaron más en 2 meses que en todo el año anterior. Y dejaron de abandonar.',
  color: 'bg-magenta-500'
}, {
  initials: 'GF',
  name: 'Gabriela F. — Córdoba',
  role: 'INSTRUCTORA DE GIMNASIA ARTÍSTICA GRUPAL E INDIVIDUAL',
  quote: 'Adapto el mismo ejercicio a 3 niveles distintos en 5 minutos. Antes me llevaba horas pensar qué hacer con un grupo mixto de edades y niveles.',
  color: 'bg-gold-500'
}];
export function InitialTestimonials() {
  return <Section className="bg-navy-800/30 border-y border-navy-700/50" data-id="element-279">
      <div className="text-center mb-5 md:mb-12" data-id="element-280">
        <h2 className="text-gold-400 font-bold tracking-widest uppercase text-xs sm:text-sm mb-1 sm:mb-2" data-id="element-281">
          Testimonios Iniciales
        </h2>
        <p className="text-xl md:text-3xl font-bold text-white" data-id="element-282">
          Lo que dicen los profes que ya no improvisan
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-3 md:gap-8" data-id="element-283">
        {initialTestimonials.map((t, i) => <div key={i} className="bg-navy-900 border border-navy-700 rounded-xl md:rounded-2xl p-4 md:p-8 relative flex flex-col h-full" data-id="element-284">
            <Quote className="absolute top-4 right-4 md:top-6 md:right-6 w-7 h-7 md:w-10 md:h-10 text-navy-700/50" data-id="element-285" />

            <div className="flex items-center space-x-1 mb-3 md:mb-6" data-id="element-286">
              {[1, 2, 3, 4, 5].map(star => <Star key={star} className="w-3 h-3 sm:w-4 sm:h-4 fill-gold-400 text-gold-400" data-id="element-287" />)}
            </div>

            <p className="text-gray-300 text-sm md:text-lg leading-relaxed mb-4 md:mb-8 flex-grow italic" data-id="element-288">
              "{t.quote}"
            </p>

            <div className="flex items-center space-x-3 mt-auto" data-id="element-289">
              <div className={`w-9 h-9 md:w-12 md:h-12 rounded-full flex items-center justify-center text-white font-bold text-sm md:text-lg ${t.color}`} data-id="element-290">
                {t.initials}
              </div>
              <div data-id="element-291">
                <p className="text-white font-bold text-sm" data-id="element-292">{t.name}</p>
                <p className="text-[10px] md:text-xs text-gray-400 font-medium tracking-wide mt-0.5" data-id="element-293">
                  {t.role}
                </p>
              </div>
            </div>
          </div>)}
      </div>
    </Section>;
}